import { api } from "./api";

export const authLogin = (data) => api.post("login", data);

const frontendUrl = window.location.origin;

export const loginWithGoogle = () =>
  api.get(`https://sso.itg.ac.id/api/auth/google?redirect_uri=${frontendUrl}`);
